export const resolveTemplate = (domain, program = null) => {
  if (program?.template) {
    return program.template;
  }
  return domain?.program?.template ?? null;
};
